// extracted by mini-css-extract-plugin
module.exports = {"chartTitle":"-chart-title-chartTitle-1c6kML-"};